import styled from 'styled-components';
import { ApMenu, ApSimpleSearch, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 280px;
  width: 280px;
  max-height: 100%;
`;

export const FilterListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 400px;
`;

export const SearchWrapper = styled.div`
  display: flex;
  padding: 8px;

  > div {
    width: 100%;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  border-top: 1px solid ${colors.grey3};
  padding: 8px 8px 0 8px;
`;

export const StyledSearch = styled(ApSimpleSearch)`
  border-radius: 0;
  border-color: ${colors.grey4};
  height: 40px;

  &:focus:enabled,
  & ~ button:focus:enabled {
    box-shadow: none;
  }

  &:focus,
  &:hover {
    border-color: ${colors.green2};
  }

  &:active {
    border-color: ${colors.green3};
  }

  &:disabled {
    pointer-events: none;
    color: ${colors.grey5};
    border-color: ${colors.grey2};
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 8px;

  &:hover {
    background: rgba(72, 137, 41, 0.1);
  }
`;

export const Label = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  padding: 8px 12px 8px 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
  width: 100%;
  flex-grow: 1;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 12px 0 8px;
  overflow: hidden;
`;

export const StyledMenu = styled(ApMenu)`
  overflow: hidden;
  display: flex;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  height: 18px;
  width: 18px;
  min-height: 18px;
  min-width: 18px;
  background-color: ${colors.green1};
  color: white;
  border-radius: 1px;
  cursor: pointer;
`;

export const NoDataWrapper = styled.div`
  padding: 8px 12px;
`;
